module.exports = __webpack_public_path__ + "img/Vue.60dfaadb.svg";